<template>
  <div :class="`${el}__step1`">
    <InViewAnimation>
      <Headline slot="1" size="l" noMargin centered responsive>
        {{ $t('intro.step1.headline') }}
      </Headline>
      <Copy slot="2" element="div" :staticClass="`${el}__step1Copy`" size="xl" centered>
        {{ $t('intro.step1.copy') }}
      </Copy>
      <Button
        slot="3"
        :class="`${el}__step1Button`"
        :href="href"
        :label="$t('intro.step1.button')"
        additionalIconName="arrow-right-line"
        @click="() => $emit('onTrackingClick', '_btn-' + $t('intro.step1.button'), 'button')"
      />
    </InViewAnimation>
  </div>
</template>

<script>
import Button from '@/objects/Button';
import Copy from '@/objects/Copy';
import Headline from '@/objects/Headline';
import InViewAnimation from '@/components/InViewAnimation';

export default {
  name: 'Step1',
  props: {
    el: String,
    href: String,
  },
  components: {
    Button,
    Copy,
    Headline,
    InViewAnimation,
  },
  data() {
    return {};
  },
};
</script>
